import React from 'react';
interface FinalCTAProps {
  onCtaClick: () => void;
}
export function FinalCTA({
  onCtaClick
}: FinalCTAProps) {
  return <footer className="w-full bg-gradient-to-br from-brand-navy via-brand-deep to-brand-navy py-8 border-t border-brand-gold/20 mt-12" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center gap-4" data-id="element-103">
          <p className="text-white/40 text-sm text-center sm:text-left" data-id="element-104">
            © 2024 Dermaclinic. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-105">
            <a href="#" className="text-white/40 text-sm hover:text-brand-gold transition-colors" data-id="element-106">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 text-sm hover:text-brand-gold transition-colors" data-id="element-107">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}